// extracted by mini-css-extract-plugin
export default {"flex":"buttons_flex__KxBR0","flexContainer":"buttons_flexContainer__tBBFA"};